import config from '../../../config'
import http from './http-util'

export default class FaroeIslandsAddressServiceApi {
  static validateAddress = ({ postalCode, street }, token) => {
    return http.get(
      token,
      `${
        config.faroeIslandsAddressServiceUrl
      }/validate_address/postal_code/${encodeURIComponent(
        postalCode,
      )}/street/${encodeURIComponent(street)}/`,
    )
  }
}
